import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  padding: 24px;
  width: 520px;
  margin-bottom: 16px;
  &.small {
    width: 325px;
  }
`;

export const Title = styled.h6`
  font-weight: bold;
  font-size: 21px;
  margin: 0;
  padding-bottom: 20px;
`;
